import { render } from "./cp_num.vue?vue&type=template&id=140ce5f7&scoped=true"
import script from "./cp_num.vue?vue&type=script&lang=js"
export * from "./cp_num.vue?vue&type=script&lang=js"

import "./cp_num.vue?vue&type=style&index=0&id=140ce5f7&scoped=scoped&lang=less"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ce5f7"]])

export default __exports__